import { ExportFormHook } from '@app/modules/social-export/hooks/useSocialExportFactory';
import { socialExport } from '@mi-front/api-clients';
import { DailymotionPublishForm } from './DailymotionPublishForm';
import { DailymotionSettingsForm } from './DailymotionSettingsForm';

export const useDailymotionExport: ExportFormHook<
  socialExport.DailymotionPublishDto,
  socialExport.DailymotionSettingsDto
> = () => {
  return {
    PublishForm: DailymotionPublishForm,
    SettingsForm: DailymotionSettingsForm,
  };
};
